import { createAction, props } from '@ngrx/store'
import { ProjectorsEntity } from './projectors.models'
import { ProjectorTemplatesEntity } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.models'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'
import { ReorderProjectorSlidesPayload } from './projectors.models'

export const loadProjectors = createAction('[Projector/API] Load Projectors ')

export const loadProjectorsSuccess = createAction(
  '[Projector/API] Load Projectors Success',
  props<{ projectors: ProjectorsEntity[] }>(),
)

export const loadProjectorsFailure = createAction(
  '[Projector/API] Load Projectors Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectProjector = createAction('[Projector/Page] Select Projector', props<{ uuid: string }>())

export const openAddEditProjectorDialog = createAction(
  '[Projector/API] Open Add/Edit Projector Dialog',
  props<{ uuid: string }>(),
)

export const openAddSlideDialog = createAction('[Projector/API] Open Add Slide Dialog')

export const openDuplicateSlideDialog = createAction(
  '[Projector/API] Open Duplicate Slide Dialog',
  props<{ projectorUuid: string }>(),
)

export const openAddProjectorTemplateDialog = createAction('[Projector/API] Open Add Projector Template Dialog')

export const addSlide = createAction(
  '[Projector/API] Add Slide',
  props<{ name: string; containerUuid: string; templateUuid?: string }>(),
)

export const addSlideSuccess = createAction(
  '[Projector/API] Add Slide Success',
  props<{ projector: ProjectorsEntity; templateUuid?: string }>(),
)

export const addSlideFailure = createAction('[Projector/API] Add Slide Failure', props<{ error: HttpErrorResponse }>())

export const reorderSlides = createAction(
  '[Projector/API] Reorder Slides',
  props<{ slides: ReorderProjectorSlidesPayload[] }>(),
)

export const reorderSlidesSuccess = createAction(
  '[Projector/API] Reorder Slides Success',
  props<{ slides: ProjectorsEntity[] }>(),
)

export const reorderSlidesFailure = createAction(
  '[Projector/API] Reorder Slides Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const addProjector = createAction(
  '[Projector/API] Add Projector',
  props<{ name: string; templateUuid: string }>(),
)

export const addProjectorSuccess = createAction(
  '[Projector/API] Add Projector Success',
  props<{ projector: ProjectorsEntity }>(),
)

export const addProjectorFailure = createAction(
  '[Projector/API] Add Projector Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateProjector = createAction(
  '[Projector/API] Update Projector',
  props<{ projector: Partial<ProjectorsEntity> }>(),
)

export const updateSelectedProjector = createAction(
  '[Projector/API] Update Selected Projector',
  props<{ projector: Partial<ProjectorsEntity> }>(),
)

export const setSelectedProjectorLocal = createAction(
  '[Projector/Local] Set Selected Projector Local',
  props<{ projector: ProjectorsEntity }>(),
)

export const patchSelectedProjectorLocal = createAction(
  '[Projector/Local] Patch Selected Projector Local',
  props<{ projector: Partial<ProjectorsEntity> }>(),
)

export const updateProjectorSuccess = createAction(
  '[Projector/API] Update Projector Success',
  props<{ update: Update<ProjectorsEntity>; showToast?: boolean }>(),
)

export const updateProjectorFailure = createAction(
  '[Projector/API] Update Projector Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteProjector = createAction('[Projector/API] Delete Projector', props<{ uuid: string }>())
export const deleteSlide = createAction(
  '[Projector/API] Delete Slide',
  props<{ uuid: string; containerUuid: string }>(),
)
export const deleteSlideSuccess = createAction(
  '[Projector/API] Delete Slide Success',
  props<{ uuid: string; containerUuid: string; previousSlideUuid?: string }>(),
)

export const deleteProjectorSuccess = createAction(
  '[Projector/API] Delete Projector Success',
  props<{ uuid: string }>(),
)

export const deleteProjectorFailure = createAction(
  '[Projector/API] Delete Projector Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const generatePresenterToken = createAction('[Projector/API] Generate presenter token for edit mode')

export const generatePresenterTokenSuccess = createAction(
  '[Projector/API] Generate presenter token for edit mode Success',
  props<{ otu_token: string }>(),
)

export const generatePresenterTokenFailure = createAction(
  '[Projector/API] Generate presenter token for edit mode Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadProjectorTemplates = createAction('[Projector/API] Load Projectors Templates')

export const loadProjectorTemplatesSuccess = createAction(
  '[Projector/API] Load Projectors Templates Success',
  props<{ templates: ProjectorTemplatesEntity[] }>(),
)

export const loadProjectorTemplatesFailure = createAction(
  '[Projector/API] Load Projectors Templates Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateProjectorTemplate = createAction(
  '[Projector/API] Update Projector Template',
  props<{ template: Partial<ProjectorTemplatesEntity> & Pick<ProjectorTemplatesEntity, 'uuid'> }>(),
)

export const updateProjectorTemplateSuccess = createAction(
  '[Projector/API] Update Projector Template Success',
  props<{ template: ProjectorTemplatesEntity }>(),
)

export const updateProjectorTemplateFailure = createAction(
  '[Projector/API] Update Projector Template Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteProjectorTemplate = createAction(
  '[Projector/API] Delete Projector Template',
  props<{ uuid: string }>(),
)

export const deleteProjectorTemplateSuccess = createAction(
  '[Projector/API] Delete Projector Template Success',
  props<{ uuid: string }>(),
)

export const deleteProjectorTemplateFailure = createAction(
  '[Projector/API] Delete Projector Template Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectNextSlide = createAction('[Projector/Page] Select Next Slide')

export const selectPreviousSlide = createAction('[Projector/Page] Select Previous Slide')

export const selectFirstSlide = createAction('[Projector/Page] Select First Slide')
